import { useState, useCallback } from 'react';

let toastIdCounter = 0;

export function useToast() {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback(({ type = 'info', title, message, duration = 4000 }) => {
    const id = ++toastIdCounter;
    setToasts((prev) => [...prev, { id, type, title, message, duration }]);
    return id;
  }, []);

  const dismissToast = useCallback((id) => {
    setToasts((prev) => prev?.filter((t) => t?.id !== id));
  }, []);

  const success = useCallback(
    (title, message, duration) => addToast({ type: 'success', title, message, duration }),
    [addToast]
  );

  const error = useCallback(
    (title, message, duration) => addToast({ type: 'error', title, message, duration }),
    [addToast]
  );

  const warning = useCallback(
    (title, message, duration) => addToast({ type: 'warning', title, message, duration }),
    [addToast]
  );

  const info = useCallback(
    (title, message, duration) => addToast({ type: 'info', title, message, duration }),
    [addToast]
  );

  return { toasts, addToast, dismissToast, success, error, warning, info };
}